var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cce3d60f4d6f8af039af85c64d0f5b80ea0b16fb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["codeapprove-app@codeapprove"]={id:"cce3d60f4d6f8af039af85c64d0f5b80ea0b16fb"};
      